import {useCallback, useEffect, useState, useMemo} from "react";
import { Filesystem, Directory } from '@capacitor/filesystem';
import openFileMobile from "../../utils/mobile/openFileMobile";

export const useDownloadFileMobile =
  (
   fileType= 'application/pdf',
   directory=Directory.External,
   openFile = true) =>
  {
  
    const initialState = useMemo(() => ({
      status: 'init',
        message: '',
        uriOrigin: '',
        fileName: '',
        uriResult: ''
    }), []);
    
    const [downloadFileData, setDownloadFileData] = useState(initialState);
    
    const setDataFileMobile = useCallback((data) => (
      setDownloadFileData({
        ...downloadFileData,
        ...data
      })
    ),[downloadFileData]);
    
    const downloadFile = useCallback(async () => {
      setDownloadFileData({
        ...initialState,
        status: 'started'
      });
      try {
        await Filesystem.writeFile({
          path: downloadFileData.fileName,
          data: downloadFileData.uriOrigin,
          directory: directory,
          /*encoding: FilesystemEncoding.UTF8*/
        }).then(async () => {
          await Filesystem.getUri({
            directory: directory,
            path: downloadFileData.fileName
          }).then((getUriResult) => {
            if(!openFile){
              setDownloadFileData({
                ...initialState,
                status: 'ok',
                message: `${downloadFileData.fileName} fue descargado correctamente`,
                uriResult: getUriResult.uri,
              });
              return;
            }
            const result= openFileMobile(getUriResult.uri, fileType, downloadFileData.fileName);
            if(result==='ok'){
              setDownloadFileData({
                ...initialState,
                status: 'ok',
                message: `Abierto ${downloadFileData.fileName}`,
                uriResult: getUriResult.uri,
              });
            } else {
              setDownloadFileData({
                ...initialState,
                status: 'error',
                message: `Error al tratar de abrir ${downloadFileData.fileName}`,
              });
            } 
          }, async () => {
            setDownloadFileData({
              ...initialState,
              status: 'error',
              message: `Error al tratar de leer ${downloadFileData.fileName}`,
            });
          });
        });
      } catch (error) {
        setDownloadFileData({
          ...initialState,
          status: 'error',
          message: `Error al tratar de guardar ${downloadFileData.fileName}`,
        });
      }
    },[directory, downloadFileData.fileName, downloadFileData.uriOrigin, fileType, initialState, openFile]);
    
    
    useEffect(() => {
      if(downloadFileData.status==='begin'){
        downloadFile().then(r => {});
      }
    },[downloadFile, downloadFileData.status, initialState]);
    
    return [downloadFileData, setDataFileMobile];
    
};